module.exports = __webpack_public_path__ + "img/Small1.dc58e608.svg";